import type { AgeFilterOption } from "components/AgeFilter"
import type { ProgressFilterOption } from "components/ProgressFilter"

export enum InstallationMoreFiltersKeys {
    PROGRESS = "progress",
    PROGRESS_OPTION = "progress_op",
    TEMPLATE = "template_id",
    PROGRAM = "program_ids",
    CATEGORY = "category_ids",
    EXECUTED_BY = "assigned_to",
    READ_UNREAD = "ReadUnread",
    TAGS = "tag_ids",
    ON_HOLD = "on_hold",
    ON_HOLD_ON = "on_hold_on",
    ON_HOLD_DATE = "on_hold_date",
    ON_HOLD_REASON = "on_hold_reason",
    ASSIGNED_VENDOR = "vendor_ids",
    BUSINESS_POC = "business_poc_ids",
    RAISED_BY = "raised_by_id",
    AGE = "age",
    AGE_OPTION = "age_op",
    RAISED_ON_START = "raised_on_start",
    RAISED_ON_END = "raised_on_end",
    RAISED_ON_OPTION = "raised_on_option",
    UPDATED_ON_START = "updated_on_start",
    UPDATED_ON_END = "updated_on_end",
    UPDATED_ON_OPTION = "updated_on_option",
    REQUESTED_CLOSURE_START = "requested_closure_start",
    REQUESTED_CLOSURE_END = "requested_closure_end",
    REQUESTED_CLOSURE_OPTION = "requested_closure_option",
    TARGET_CLOSURE_START = "target_closure_start",
    TARGET_CLOSURE_END = "target_closure_end",
    TARGET_CLOSURE_OPTION = "target_closure_option",
    CHARGER_TYPE = "charger_type",
    COUNTRY = "country",
    ZONES = "region_ids",
    STATES = "state_id",
    CITIES = "city_id",
}

type DropdownOption = { id: string | number; title: string }

export type InstallationMoreFiltersType = {
    [InstallationMoreFiltersKeys.PROGRESS]: number[]
    [InstallationMoreFiltersKeys.PROGRESS_OPTION]: ProgressFilterOption | null
    [InstallationMoreFiltersKeys.TEMPLATE]: DropdownOption[]
    [InstallationMoreFiltersKeys.PROGRAM]: DropdownOption[]
    [InstallationMoreFiltersKeys.CATEGORY]: DropdownOption[]
    [InstallationMoreFiltersKeys.EXECUTED_BY]: DropdownOption | null
    [InstallationMoreFiltersKeys.READ_UNREAD]: DropdownOption | null
    [InstallationMoreFiltersKeys.TAGS]: DropdownOption[]
    [InstallationMoreFiltersKeys.ON_HOLD]: DropdownOption | null
    [InstallationMoreFiltersKeys.ON_HOLD_ON]: DropdownOption | null
    [InstallationMoreFiltersKeys.ON_HOLD_DATE]: string
    [InstallationMoreFiltersKeys.ON_HOLD_REASON]: DropdownOption[]
    [InstallationMoreFiltersKeys.ASSIGNED_VENDOR]: DropdownOption[]
    [InstallationMoreFiltersKeys.BUSINESS_POC]: DropdownOption[]
    [InstallationMoreFiltersKeys.RAISED_BY]: DropdownOption | null
    [InstallationMoreFiltersKeys.AGE]: number[]
    [InstallationMoreFiltersKeys.AGE_OPTION]: AgeFilterOption | null
    [InstallationMoreFiltersKeys.RAISED_ON_START]: string
    [InstallationMoreFiltersKeys.RAISED_ON_END]: string
    [InstallationMoreFiltersKeys.RAISED_ON_OPTION]: DropdownOption | null
    [InstallationMoreFiltersKeys.UPDATED_ON_START]: string
    [InstallationMoreFiltersKeys.UPDATED_ON_END]: string
    [InstallationMoreFiltersKeys.UPDATED_ON_OPTION]: DropdownOption | null
    [InstallationMoreFiltersKeys.REQUESTED_CLOSURE_START]: string
    [InstallationMoreFiltersKeys.REQUESTED_CLOSURE_END]: string
    [InstallationMoreFiltersKeys.REQUESTED_CLOSURE_OPTION]: DropdownOption | null
    [InstallationMoreFiltersKeys.TARGET_CLOSURE_START]: string
    [InstallationMoreFiltersKeys.TARGET_CLOSURE_END]: string
    [InstallationMoreFiltersKeys.TARGET_CLOSURE_OPTION]: DropdownOption | null
    [InstallationMoreFiltersKeys.CHARGER_TYPE]: DropdownOption | null
    [InstallationMoreFiltersKeys.COUNTRY]: DropdownOption | null
    [InstallationMoreFiltersKeys.ZONES]: DropdownOption[]
    [InstallationMoreFiltersKeys.STATES]: DropdownOption[]
    [InstallationMoreFiltersKeys.CITIES]: DropdownOption[]
}

export const INITIAL_MORE_FILTERS: InstallationMoreFiltersType = {
    [InstallationMoreFiltersKeys.PROGRESS]: [],
    [InstallationMoreFiltersKeys.PROGRESS_OPTION]: null,
    [InstallationMoreFiltersKeys.TEMPLATE]: [],
    [InstallationMoreFiltersKeys.PROGRAM]: [],
    [InstallationMoreFiltersKeys.CATEGORY]: [],
    [InstallationMoreFiltersKeys.EXECUTED_BY]: null,
    [InstallationMoreFiltersKeys.READ_UNREAD]: null,
    [InstallationMoreFiltersKeys.TAGS]: [],
    [InstallationMoreFiltersKeys.ON_HOLD]: null,
    [InstallationMoreFiltersKeys.ON_HOLD_ON]: null,
    [InstallationMoreFiltersKeys.ON_HOLD_DATE]: "",
    [InstallationMoreFiltersKeys.ON_HOLD_REASON]: [],
    [InstallationMoreFiltersKeys.ASSIGNED_VENDOR]: [],
    [InstallationMoreFiltersKeys.BUSINESS_POC]: [],
    [InstallationMoreFiltersKeys.RAISED_BY]: null,
    [InstallationMoreFiltersKeys.AGE]: [],
    [InstallationMoreFiltersKeys.AGE_OPTION]: null,
    [InstallationMoreFiltersKeys.RAISED_ON_START]: "",
    [InstallationMoreFiltersKeys.RAISED_ON_END]: "",
    [InstallationMoreFiltersKeys.RAISED_ON_OPTION]: null,
    [InstallationMoreFiltersKeys.UPDATED_ON_START]: "",
    [InstallationMoreFiltersKeys.UPDATED_ON_END]: "",
    [InstallationMoreFiltersKeys.UPDATED_ON_OPTION]: null,
    [InstallationMoreFiltersKeys.REQUESTED_CLOSURE_START]: "",
    [InstallationMoreFiltersKeys.REQUESTED_CLOSURE_END]: "",
    [InstallationMoreFiltersKeys.REQUESTED_CLOSURE_OPTION]: null,
    [InstallationMoreFiltersKeys.TARGET_CLOSURE_START]: "",
    [InstallationMoreFiltersKeys.TARGET_CLOSURE_END]: "",
    [InstallationMoreFiltersKeys.TARGET_CLOSURE_OPTION]: null,
    [InstallationMoreFiltersKeys.CHARGER_TYPE]: null,
    [InstallationMoreFiltersKeys.COUNTRY]: null,
    [InstallationMoreFiltersKeys.ZONES]: [],
    [InstallationMoreFiltersKeys.STATES]: [],
    [InstallationMoreFiltersKeys.CITIES]: [],
}
